import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import styled from 'styled-components';
const Container = styled.div `
  position: relative;
  flex: 1 2;
`;
const List = styled.dl `
  will-change: opacity;
  transition: opacity 0.3s ease;
  opacity: 1;

  &[data-is-showing='false'] {
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
  }
`;
const Key = styled.dt `
  ${fonts.brandonGrotesque.regular};

  font-size: ${fluid(16, 20)};
  line-height: ${fluid(20, 24)};
  text-transform: uppercase;
  border-left: ${fluid(2, 4)} solid ${brand.green};
  padding-left: ${fluid(16, 24)};

  [data-background='green'] & {
    border-color: ${brand.beige};
    color: ${brand.white};
  }
`;
const Value = styled.dd `
  ${fonts.zahrah.medium};
  font-size: ${fluid(24, 28)};
  line-height: ${fluid(28, 32)};
  margin-bottom: ${fluid(20, 40)};
  border-left: ${fluid(2, 4)} solid ${brand.green};
  padding-left: ${fluid(16, 24)};

  [data-background='green'] & {
    border-color: ${brand.beige};
    color: ${brand.white};
  }
`;
const KeyValuesListStyles = {
    Container,
    List,
    Key,
    Value,
};
export default KeyValuesListStyles;
